'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import AnchorLink from '@/components/AnchorLink';
import TagButton from '@/components/TagButton';
import IconDiamond from '@/components/assets/icon_diamond.svg';
import IconFavorite from '@/components/assets/icon_favorite_enable.svg';
import IconFollow from '@/components/assets/icon_follow.svg';
import IconFriend from '@/components/assets/icon_friend.svg';
import IconHome from '@/components/assets/icon_home.svg';
import IconWorld from '@/components/assets/icon_my_worlds.svg';
import IconRating from '@/components/assets/icon_rating.svg';
import IconRecord from '@/components/assets/icon_record.svg';
import IconUnlocked from '@/components/assets/icon_unlocked.svg';
import { useLayoutContext } from '@/context/LayoutContext';
import { useUAContext } from '@/context/UAContext';
import { useActiveSection } from '@/hooks/useActiveSection';
const anchorIds = ['about', 'worlds', 'games', 'experiences', 'persona', 'following-creators', 'following', 'favorites', 'premium', 'unlocked', 'featured', 'videos'] as const;
function ProfileAnchors() {
  const $ = _c(68);
  const t = useTranslations();
  const activeId = useActiveSection(anchorIds);
  const {
    headerHeight
  } = useLayoutContext();
  const {
    isIosMobileApp
  } = useUAContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [visibleIds, setVisibleIds] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const checkElements = () => {
        const foundIds = anchorIds.filter(_temp);
        setVisibleIds(foundIds);
      };
      const observer = new MutationObserver(checkElements);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== headerHeight) {
    t3 = {
      top: headerHeight
    };
    $[3] = headerHeight;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeId || $[6] !== t || $[7] !== visibleIds) {
    t4 = visibleIds.includes("about") && <AnchorLink href="#about"><TagButton active={activeId === "about"} className="px-4 text-[14px] lg:py-2 lg:text-[14px]" tagIcon={<IconHome className="size-5" />}>{t("profile-page.anchors.about")}</TagButton></AnchorLink>;
    $[5] = activeId;
    $[6] = t;
    $[7] = visibleIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeId || $[10] !== t || $[11] !== visibleIds) {
    t5 = visibleIds.includes("featured") && <AnchorLink href="#featured"><TagButton active={activeId === "featured"} className="px-4 text-[14px] lg:py-2 lg:text-[14px]" tagIcon={<IconRating className="fill-vive-primary-20" />}>{t("user-worlds.sort-option.featured")}</TagButton></AnchorLink>;
    $[9] = activeId;
    $[10] = t;
    $[11] = visibleIds;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== activeId || $[14] !== isIosMobileApp || $[15] !== t || $[16] !== visibleIds) {
    t6 = visibleIds.includes("premium") && !isIosMobileApp && <AnchorLink href="#premium"><TagButton active={activeId === "premium"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconDiamond className="fill-vive-primary-20" />}>{t("profile-page.anchors.premium")}</TagButton></AnchorLink>;
    $[13] = activeId;
    $[14] = isIosMobileApp;
    $[15] = t;
    $[16] = visibleIds;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== activeId || $[19] !== t || $[20] !== visibleIds) {
    t7 = visibleIds.includes("worlds") && <AnchorLink href="#worlds"><TagButton active={activeId === "worlds"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconWorld className="size-6" />}>{t("profile-page.anchors.content")}</TagButton></AnchorLink>;
    $[18] = activeId;
    $[19] = t;
    $[20] = visibleIds;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== activeId || $[23] !== t || $[24] !== visibleIds) {
    t8 = visibleIds.includes("games") && <AnchorLink href="#games"><TagButton active={activeId === "games"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconWorld className="size-6" />}>{t("profile-page.anchors.games")}</TagButton></AnchorLink>;
    $[22] = activeId;
    $[23] = t;
    $[24] = visibleIds;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== activeId || $[27] !== t || $[28] !== visibleIds) {
    t9 = visibleIds.includes("experiences") && <AnchorLink href="#experiences"><TagButton active={activeId === "experiences"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconWorld className="size-6" />}>{t("profile-page.anchors.experiences")}</TagButton></AnchorLink>;
    $[26] = activeId;
    $[27] = t;
    $[28] = visibleIds;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== activeId || $[31] !== t || $[32] !== visibleIds) {
    t10 = visibleIds.includes("videos") && <AnchorLink href="#videos"><TagButton active={activeId === "videos"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconRecord className="fill-vive-primary-20 size-6" />}>{t("media-browser.nav_title.videos")}</TagButton></AnchorLink>;
    $[30] = activeId;
    $[31] = t;
    $[32] = visibleIds;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== activeId || $[35] !== t || $[36] !== visibleIds) {
    t11 = visibleIds.includes("favorites") && <AnchorLink href="#favorites"><TagButton active={activeId === "favorites"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconFavorite className="size-6" />}>{t("profile-page.anchors.favorites")}</TagButton></AnchorLink>;
    $[34] = activeId;
    $[35] = t;
    $[36] = visibleIds;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== activeId || $[39] !== t || $[40] !== visibleIds) {
    t12 = visibleIds.includes("unlocked") && <AnchorLink href="#unlocked"><TagButton active={activeId === "unlocked"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconUnlocked className="size-6" />}>{t("profile-page.anchors.unlocked")}</TagButton></AnchorLink>;
    $[38] = activeId;
    $[39] = t;
    $[40] = visibleIds;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== activeId || $[43] !== t || $[44] !== visibleIds) {
    t13 = visibleIds.includes("persona") && <AnchorLink href="#persona"><TagButton active={activeId === "persona"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconFollow className="size-6" />}>{t("profile-page.anchors.persona")}</TagButton></AnchorLink>;
    $[42] = activeId;
    $[43] = t;
    $[44] = visibleIds;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== activeId || $[47] !== t || $[48] !== visibleIds) {
    t14 = visibleIds.includes("following-creators") && <AnchorLink href="#following-creators"><TagButton active={activeId === "following-creators"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconFriend className="size-6" />}>{t("profile-page.anchors.following-creators")}</TagButton></AnchorLink>;
    $[46] = activeId;
    $[47] = t;
    $[48] = visibleIds;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== activeId || $[51] !== t || $[52] !== visibleIds) {
    t15 = visibleIds.includes("following") && <AnchorLink href="#following"><TagButton active={activeId === "following"} className="px-4 lg:py-2 lg:text-[14px]" tagIcon={<IconFollow className="size-6" />}>{t("profile-page.anchors.feed")}</TagButton></AnchorLink>;
    $[50] = activeId;
    $[51] = t;
    $[52] = visibleIds;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t10 || $[55] !== t11 || $[56] !== t12 || $[57] !== t13 || $[58] !== t14 || $[59] !== t15 || $[60] !== t3 || $[61] !== t4 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t16 = <nav data-component="profile-anchors" className="bg-background no-scrollbar sticky z-30 flex flex-nowrap gap-3 overflow-x-auto overflow-y-hidden px-4 py-2 md:px-8 lg:px-18 lg:py-4" style={t3}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</nav>;
    $[54] = t10;
    $[55] = t11;
    $[56] = t12;
    $[57] = t13;
    $[58] = t14;
    $[59] = t15;
    $[60] = t3;
    $[61] = t4;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t16;
  } else {
    t16 = $[67];
  }
  return t16;
}
function _temp(id) {
  return document.getElementById(id);
}
export default ProfileAnchors;